import React from 'react';
import PropTypes from 'prop-types';

import {
  getUserFields,
  getUserFieldByRole,
} from '../../helpers/UserFields';

const UserProfileTitle = ({ profile }) => {
  const userFields = getUserFields(profile);
  const jobTitle = getUserFieldByRole(userFields, 'job_title');

  return (
    <div className="user-profile-title">
      <h3>{profile.name}</h3>
      {(jobTitle && jobTitle.value) && (
        <h5 className="job-title">{jobTitle.value}</h5>
      )}
    </div>
  );
};

UserProfileTitle.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default UserProfileTitle;
